import $api from "@/api";
import { type Appeal } from "@/modules/appeal/types";

export async function createAppeal(body: any) {
  return $api.post("/appeal/new-appeal", body);
}

export async function getAppealsBySearch(search: string) {
  const params = new URLSearchParams();

  params.append("search_string", search);

  return $api.get<{ appeals: Appeal[] }>("/manager/appeals", { params });
}

export async function getAppealsAmount() {
  return $api.get("/manager/appeals/amount");
}
